import './AppTextField.css';

/**
 * Выбор даты и времени.
 *
 * На Android это свои диалоги `DatePickDialog` и `TimePickDialog`: четыре собранные
 * вручную копии успели разойтись на часовых поясах. В вебе роль общего компонента играет
 * системный выбор iOS — колесо, к которому юрист привык, и которое нам не нужно
 * повторять и поддерживать.
 *
 * Отступление от Android-версии сознательное: свой календарь в вебе выглядел бы чужим
 * на iPhone, а системный доступен одной строкой и умеет всё, включая доступность.
 * Значение хранится и отдаётся строкой `ГГГГ-ММ-ДД` (или `ЧЧ:ММ`) — часовой пояс
 * появляется только при сборке момента времени, в одном месте.
 */
export function AppDateField({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  label: string;
}) {
  return (
    <label className="field">
      <input
        className="field__control"
        type="date"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <span className="field__label">{label}</span>
    </label>
  );
}

export function AppTimeField({
  value,
  onChange,
  label,
}: {
  value: string;
  onChange: (value: string) => void;
  label: string;
}) {
  return (
    <label className="field">
      <input
        className="field__control"
        type="time"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <span className="field__label">{label}</span>
    </label>
  );
}
